import React, { useEffect, useState } from 'react';
import { Box, Typography, Card, CardContent, Button, Grid, Divider } from '@mui/material';
import { styled } from '@mui/system';
import { useNavigate, useLocation } from 'react-router-dom'; 
import { auth, db } from '../firebase';  
import { doc, getDoc, updateDoc } from 'firebase/firestore';  
import CustomHeader from './CustomHeader';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import defaultProfileImage from './perfil.png';
import VerifiedIcon from '@mui/icons-material/Verified'; 
import WarningIcon from '@mui/icons-material/Warning'; 
import axios from 'axios';
import { loadStripe } from '@stripe/stripe-js';
import { getAuth } from 'firebase/auth';

const stripePromise = loadStripe('pk_live_51P8649RrYSgIriRX62mwa398w65Z83nozZ9P375RMSKrChXWpPrTXmNzrFXwHnDBUzWvgT7oBPfcwjpAHo3DCW8u00pVITVoUG');

const Container = styled(Box)({
  padding: '20px',
  maxWidth: '800px',
  margin: '0 auto',
  marginTop: '140px',  
  paddingBottom: '100px',
});

const CardBox = styled(Card)({
  marginBottom: '20px',
  border: '1px solid #2A9D8E',
  borderRadius: '8px',
  boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
});

const ProfileImage = styled('img')({
  width: '120px',
  height: '120px',
  borderRadius: '50%',
  objectFit: 'cover',
  marginRight: '20px',
});

const PlanCard = styled(Card)({
  border: '1px solid #2A9D8E',
  borderRadius: '8px',
  padding: '16px',
  marginBottom: '16px',
  boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',  
});

const PlanButton = styled(Button)({
  marginTop: '10px',
  backgroundColor: '#2A9D8E',
  color: '#fff',
  '&:hover': {
    backgroundColor: '#21867A',
  },
});

const BackButton = styled(Button)({
  marginBottom: '20px',
  backgroundColor: '#2A9D8E',
  color: '#fff',
  '&:hover': {
    backgroundColor: '#21867A',
  },
  display: 'flex',
  alignItems: 'center',
});

const AdvantageItem = styled(Typography)({
  display: 'flex',
  alignItems: 'center',
  marginBottom: '8px',
});

const HighlightedMessage = styled(Typography)({
  display: 'flex',
  alignItems: 'center',
  backgroundColor: '#ffe6e6',
  padding: '10px',
  borderRadius: '8px',
  marginBottom: '16px',
  color: '#FF4D4D',
});

const WarningMessage = styled(Typography)({
  display: 'flex',
  alignItems: 'center',
  backgroundColor: '#ffe6e6',
  padding: '10px',
  borderRadius: '8px',
  marginBottom: '16px',
  color: '#FF4D4D',
});

const MinhaConta = () => {
  const [cliente, setCliente] = useState(null);
  const navigate = useNavigate();
  const location = useLocation(); // Adicionado para pegar a URL atual

 useEffect(() => {
  const fetchCuidadorData = async () => {
    try {
      const user = auth.currentUser;

      if (!user) {
        // Redireciona imediatamente para a página inicial (que é a página de login)
        navigate('/');
        return;
      }

      const cuidadorRef = doc(db, 'cuidadores', user.uid);
      const docSnap = await getDoc(cuidadorRef);
      
      if (docSnap.exists()) {
        setCliente(docSnap.data());
      } else {
        console.error('Nenhum documento encontrado!');
        navigate('/'); // Redireciona para a página inicial se o documento não for encontrado
      }
    } catch (error) {
      console.error('Erro ao buscar os dados do cuidador:', error);
      navigate('/'); // Redireciona para a página inicial em caso de erro
    }
  };

  fetchCuidadorData();
}, [navigate]);






const handleCheckout = async (priceId, plano) => {
  const stripe = await stripePromise;
  const user = auth.currentUser;

  if (!user) {
    console.error('Usuário não autenticado!');
    return;
  }

  try {
    const cuidadorRef = doc(db, 'cuidadores', user.uid); // Ajustado para a coleção 'cuidadores'
    await updateDoc(cuidadorRef, { planoescolhido: plano });

    const response = await axios.post('https://us-central1-carey-appy.cloudfunctions.net/createCheckoutSession', {
      priceId,
      uid: user.uid,
    });

    const { id } = response.data;
    const { error } = await stripe.redirectToCheckout({ sessionId: id });
    if (error) {
      console.error('Erro ao redirecionar para o checkout:', error);
    }
  } catch (error) {
    console.error('Erro ao criar a sessão de checkout:', error);
  }
};


  if (!cliente) return <Typography>Carregando...</Typography>;

  const avatarUrl = cliente.avatar || defaultProfileImage;

const assinaturaStatusMessage = cliente && cliente.tipodeconta === 'Sem Plano'
  ? (
      <>
        <WarningMessage>
          <WarningIcon sx={{ marginRight: '8px' }} />
          Você precisa assinar um plano para entrar em contato com as vagas e oportunidades.
        </WarningMessage>
        <Typography
          variant="h6"
          sx={{
            backgroundColor: '#FFD700',
            color: '#000',
            padding: '16px',
            borderRadius: '8px',
            textAlign: 'center',
            marginTop: '16px',
            fontWeight: 'bold',
            marginBottom: '10px',
          }}
        >
          50% de desconto na primeira mensalidade de qualquer plano! Use o cupom: <strong>CAREYCUIDADORES</strong>
        </Typography>
      </>
    )
  : cliente && (
      <HighlightedMessage>
        <VerifiedIcon sx={{ marginRight: '8px' }} />
        Você é um assinante do plano <strong>"{cliente ? cliente.tipodeconta : 'N/A'}"</strong>
      </HighlightedMessage>
    );



  return (
    <>
      <CustomHeader />
      <Container>
       

        <CardBox>
          <CardContent>
            <Grid container spacing={2}>
              
              <Grid item xs={12} md={8}>
                <Typography variant="h6" color="#2A9D8E" gutterBottom>
                  Dados Cadastrais
                </Typography>
                <Typography><strong>Nome:</strong> {cliente.name}</Typography>
                <Typography><strong>Email:</strong> {cliente.email}</Typography>
                
       
                <Typography><strong>Tipo de Cadastro:</strong> {cliente.tipoDeCadastro}</Typography>
                <Typography><strong>Assinatura:</strong> {cliente.tipodeconta}</Typography>  
              </Grid>
            </Grid>
          </CardContent>
        </CardBox>

       <CardBox>
  <CardContent>
    <Typography variant="h6" color="#2A9D8E" gutterBottom>
      Minhas Assinaturas
    </Typography>
    {assinaturaStatusMessage}
    {cliente.tipodeconta === 'Sem Plano' || !cliente.tipodeconta ? (
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <PlanCard>
            <div>
              <Typography variant="h6">Plano Mensal</Typography>
              <Typography variant="h5">R$ 36,90/mês</Typography>
              <Divider sx={{ margin: '16px 0' }} />  
              <AdvantageItem><CheckCircleIcon sx={{ color: '#8BD4CC', marginRight: '8px' }} /> Contatos ilimitados</AdvantageItem>
              <AdvantageItem><CheckCircleIcon sx={{ color: '#8BD4CC', marginRight: '8px' }} /> Acesso a todas as funcionalidades</AdvantageItem>
              
              <AdvantageItem><CheckCircleIcon sx={{ color: '#8BD4CC', marginRight: '8px' }} /> Mais Famílias Interessados</AdvantageItem>
              <AdvantageItem><CheckCircleIcon sx={{ color: '#8BD4CC', marginRight: '8px' }} /> Fale com Todas as Vagas</AdvantageItem>
              
            </div>
            <PlanButton fullWidth onClick={() => handleCheckout('price_1PrA9FRrYSgIriRXXpd2vfBv', 'Mensal')}>
              Assinar Plano Mensal
            </PlanButton>
          </PlanCard>
        </Grid>
        <Grid item xs={12} md={6}>
          <PlanCard>
            <div>
              <Typography variant="h6">Plano Trimestral</Typography>
              <Typography variant="h5">R$ 90,90/trimestre</Typography>
              <Typography>equivalente a R$ 30,30/mês</Typography>
              <Divider sx={{ margin: '16px 0' }} />  
              <AdvantageItem><CheckCircleIcon sx={{ color: '#8BD4CC', marginRight: '8px' }} /> Contatos ilimitados</AdvantageItem>
              <AdvantageItem><CheckCircleIcon sx={{ color: '#8BD4CC', marginRight: '8px' }} /> Acesso a todas as funcionalidades</AdvantageItem>
              
              <AdvantageItem><CheckCircleIcon sx={{ color: '#8BD4CC', marginRight: '8px' }} /> Mais Famílias Interessadas</AdvantageItem>
<AdvantageItem><CheckCircleIcon sx={{ color: '#8BD4CC', marginRight: '8px' }} /> Fale com Todas as vagas</AdvantageItem>
              <AdvantageItem><CheckCircleIcon sx={{ color: '#8BD4CC', marginRight: '8px' }} /> Desconto especial</AdvantageItem>
            </div>
            <PlanButton fullWidth onClick={() => handleCheckout('price_1PrAC4RrYSgIriRXhjygavWK', 'Trimestral')}>
              Assinar Plano Trimestral
            </PlanButton>
          </PlanCard>
        </Grid>

 
      </Grid>

        
      
    ) : null}
  </CardContent>
</CardBox>


<CardBox>
  <CardContent>
    <Grid container spacing={2} justifyContent="center">
      <Grid item xs={12} md={6}>
        <Button
          fullWidth
          variant="outlined"
          sx={{
            borderColor: '#FF4D4D',
            color: '#FF4D4D',
            '&:hover': {
              backgroundColor: '#FF4D4D',
              color: '#fff',
              borderColor: '#FF4D4D', // Mantém a borda vermelha no hover
            },
            '&:focus': {
              outline: 'none', // Remove o contorno azul padrão
            },
            textTransform: 'none', // Mantém o texto em sua forma original (não em maiúsculas)
          }}
          startIcon={<WarningIcon />}
          href="https://carey.app.br/deletar-conta/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Deletar Conta
        </Button>
      </Grid>
    </Grid>
  </CardContent>
</CardBox>

 <BackButton fullWidth onClick={() => navigate('/home')}>
          <ArrowBackIcon sx={{ marginRight: '8px' }} />
          Voltar para Home
        </BackButton>


      </Container>
    </>
  );
};

export default MinhaConta;